// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "CreateCollectionModal" + "." + "ee378bd6cae42897" + ".js"
}